import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import CommunityCreate from './create/CommunityCreate';

const Container = styled.div`
  display: flex;
`;

const CommunitiesHeaderActions = () => {
  const { currentUser } = useAppSelector((state) => state.auth);

  return <Container>{currentUser?.isSuperuser && <CommunityCreate />}</Container>;
};

export default CommunitiesHeaderActions;
